import { render, staticRenderFns } from "./DeckItemList.vue?vue&type=template&id=512d63b0&scoped=true"
import script from "./DeckItemList.vue?vue&type=script&lang=ts"
export * from "./DeckItemList.vue?vue&type=script&lang=ts"
import style0 from "./DeckItemList.vue?vue&type=style&index=0&id=512d63b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512d63b0",
  null
  
)

export default component.exports